import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type AppModal =
  | 'createUser'
  | 'logout'
  | 'patientFilters'
  | 'editPatientInfo'
  | 'archivePatient'
  | 'removeAssignment'
  | 'reassignUser'
  | 'uploadPatientFiles'
  | 'tasksModal'
  | 'treatmentModal'
  | 'uploadPatientFiles'
  | 'addPatientLinks'
  | 'activityFeed'
  | 'dashboardFilter'
  | 'treatmentAndDiagnosisError'
  | 'messagingErrorModal'
  | 'attachmentErrorModal'
  | 'startTreatment'
  | 'deletePatient';

export type ModalErrors =
  | 'treatmentAndDiagnosisError'
  | 'messagingError'
  | 'attachmentError'
  | 'createUserError'
  | 'createPatientError'
  | 'editPatientError'
  | 'toggleArchivePatient'
  | 'patientComplainError'
  | 'patientLinksError'
  | 'credentialError'
  | 'editUserError'
  | 'deletePatientError';

export type CurrentPatientTab = 'information' | 'discussion';

export interface AppState {
  modals: {
    [key in AppModal]: boolean;
  };
  showPatientCaseList: boolean;
  currentPatientTab: CurrentPatientTab;
  appIsLoading: boolean;
  modalsErrors: {
    [key in ModalErrors]: string;
  };
  sseConnected: boolean;
}

export const initialState: AppState = {
  modals: {
    createUser: false,
    logout: false,
    patientFilters: false,
    editPatientInfo: false,
    archivePatient: false,
    removeAssignment: false,
    reassignUser: false,
    tasksModal: false,
    treatmentModal: false,
    uploadPatientFiles: false,
    addPatientLinks: false,
    activityFeed: false,
    dashboardFilter: false,
    treatmentAndDiagnosisError: false,
    messagingErrorModal: false,
    attachmentErrorModal: false,
    startTreatment: false,
    deletePatient: false,
  },
  showPatientCaseList: true,
  currentPatientTab: 'information',
  appIsLoading: false,
  modalsErrors: {
    treatmentAndDiagnosisError: '',
    messagingError: '',
    attachmentError: '',
    createUserError: '',
    createPatientError: '',
    editPatientError: '',
    toggleArchivePatient: '',
    patientComplainError: '',
    patientLinksError: '',
    credentialError: '',
    editUserError: '',
    deletePatientError: '',
  },
  sseConnected: false,
};

export const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsModalOpened: (state, { payload }: PayloadAction<{ name: AppModal; isOpened: boolean }>) => {
      state.modals = { ...state.modals, [payload.name]: payload.isOpened };
    },
    setShowPatientCaseList: (state, { payload }: PayloadAction<boolean>) => {
      state.showPatientCaseList = payload;
    },
    setCurrentPatientTab: (state, { payload }: PayloadAction<CurrentPatientTab>) => {
      state.currentPatientTab = payload;
    },
    setAppIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.appIsLoading = payload;
    },
    setModalErrorText: (state, { payload }: PayloadAction<{ name: ModalErrors; errorText: string }>) => {
      state.modalsErrors = { ...state.modalsErrors, [payload.name]: payload.errorText };
    },
    setSSEConnected: (state, { payload }: PayloadAction<boolean>) => {
      state.sseConnected = payload;
    },
  },
});

export const appActions = slice.actions;
export const appReducer = slice.reducer;
